'use strict';

const saActiveState = [
  '$rootScope',
  '$state',

  function ($rootScope, $state) {
    return {
      link: function ($scope, $element, $attr) {
        var classToAdd = $attr.addClass;
        var expectedState = $attr.saActiveState;

        function updateState() {
          if ($state.is(expectedState)) {
            $element.addClass(classToAdd);
          } else {
            $element.removeClass(classToAdd);
          }
        }

        updateState();

        $rootScope.$on('$stateChangeSuccess', updateState);
      }
    };
  }
];

export default saActiveState;



// WEBPACK FOOTER //
// ./app/src/directives/active_state.js